'use client'
import { useAuth } from '@clerk/nextjs'
import { usePageContentReadiness } from '@/hooks/use-page-content-readiness'

/** Clerk runtime readiness is separate from the vendor widget's resource/render timings. */
export function AuthRuntimeReady() {
  const { isLoaded } = useAuth()
  usePageContentReadiness(
    [
      'web_sign_in_sign_in',
      'web_sign_up_sign_up',
      'web_create_organization_create_organization',
    ],
    isLoaded ? 'ready' : 'loading'
  )
  return null
}
